import React from "react";

function Settings() {
  return <h1>Settings Pro</h1>;
}

export default Settings;
